module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_12-ebba7dda32544b7942f7ebd0cd4388ff.jpg";